<template>
  <div>
    <Button
      id="remove-payment-settings"
      :class="`${ButtonSeverityClass.SECONDARY} ${ButtonStateClass.OUTLINE} border-none`"
      :label="t('sites.singleSite.financialConfig.paymentInfo.actions.removePaymentSettings')"
      @click.stop="openDeleteConfirmation"
      v-if="hasPaymentConfig && editPaymentInfo"
    >
      <template #icon>
        <i class="material-symbols-rounded text-[1.5rem] mr-2">delete</i>
      </template>
    </Button>

    <DeleteConfirmation v-model="showDeleteConfirmation" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import { usePaymentInfo } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '@centric-os/sites/src/routes';
import DeleteConfirmation from './delete-confirmation/DeleteConfirmation.vue';
import {
  ButtonSeverityClass,
  ButtonStateClass,
} from '@centric-os/components/src/core/buttons/enums';

// Since this component is only used for station config, we don't need the isSiteConfig prop

// Set localization
const { t } = useI18n();

// Ref for show delete confirmation
const showDeleteConfirmation = ref<boolean>(false);

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo } = storeToRefs(fConfigStore);

// Set payment info composable
const { hasPaymentConfig } = usePaymentInfo();

// Method to open delete confirmation
const openDeleteConfirmation = (): void => {
  showDeleteConfirmation.value = true;
};
</script>
